import { render, staticRenderFns } from "./MarketplaceDetails.vue?vue&type=template&id=efb80326&scoped=true&"
import script from "./MarketplaceDetails.vue?vue&type=script&lang=js&"
export * from "./MarketplaceDetails.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceDetails.vue?vue&type=style&index=0&id=efb80326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb80326",
  null
  
)

export default component.exports